class PromiseCache {
  private cache: Map<string, Promise<any>>;
  private cacheDuration: number;

  constructor(cacheDuration: number = 5000) {
    this.cache = new Map();
    this.cacheDuration = cacheDuration;
  }

  get(promiseProvider: () => Promise<any>, keys: string | string[], duration = this.cacheDuration) {
    if (typeof keys === 'string') {
      keys = [keys];
    }
    const key = keys.join(':');
    if (!this.cache.has(key)) {
      const promise = promiseProvider()
        .catch((error) => {
          // Ensure that errors are not cached
          this.cache.delete(key);
          throw error;
        })
        .then((data) => {
          // Schedule cache invalidation
          if (duration >= 0) {
            setTimeout(() => {
              this.cache.delete(key);
            }, duration);
          }
          return data;
        });
      this.cache.set(key, promise);
    }
    return this.cache.get(key)!;
  }
}

export function objectToKeys(obj: any): string[] {
  return Object.values(obj).reduce<string[]>((arr, v) => {
    arr.push(String(v));
    return arr;
  }, [] as string[]);
}

export default new PromiseCache();
